export default __webpack_public_path__ + "static/media/Scope-8.9e584b4a.png";